import { showHideInputError } from "./input";

export default () => {
  Alpine.data("select", () => ({
    value: null,
    open: false,

    init() {
      const initialValue = this.$refs.input.value;

      // Ensures component state is in sync with hidden input's value, can be set programmatically.
      Object.defineProperty(this.$refs.input, "value", {
        get: () => this.value,
        set: (value) => this.value = String(value),
      });

      // Watch for value change, and update component state.
      this.$watch("value", value => {
        // Allows Alpine value to be picked up by browser if within a <form>.
        if (value != null) {
          this.$refs.input.setAttribute("value", value);
        } else {
          this.$refs.input.removeAttribute("value");
        }

        const valueTarget = this.$refs.dropdown.querySelector(`[data-value='${value}']`);
        if (!valueTarget && value != null) {
          return this.value = null;
        }

        this.$refs.content.innerHTML = value == null ? "" : valueTarget.innerHTML;
        this.open = false;

        this.$refs.input.dispatchEvent(new Event("change", { bubbles: true }));
      });

      // Use nextTick to prevent race condition, where value is set before change
      // event listeners are registered by Stimulus. Ensures that the change event
      // is fired if a value is set on a combobox upon initial page load.
      this.$nextTick(() => this.value = initialValue);
    },

    showHideInputError(e) {
      showHideInputError(e, this.$refs.container, this.$refs.error);
    }
  }));
}
